import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleComeUsare from "../pages/article/come-usare-itaobuy-spreadsheet";
import ArticleSicurezza from "../pages/article/itaobuy-spreadsheet-sicurezza";
import ArticleConfronto from "../pages/article/itaobuy-spreadsheet-confronto";
import ArticleCategorie from "../pages/article/itaobuy-spreadsheet-categorie";
import ArticleVantaggi from "../pages/article/itaobuy-spreadsheet-vantaggi";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/guida-completa-itaobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/articolo/come-usare-itaobuy-spreadsheet",
    element: <ArticleComeUsare />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-sicurezza",
    element: <ArticleSicurezza />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-confronto",
    element: <ArticleConfronto />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-categorie",
    element: <ArticleCategorie />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-vantaggi",
    element: <ArticleVantaggi />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;